/**
 * Fotos de agente («ficha») — mapa en el FRONT por id. MVP mientras el kernel
 * no emita `avatar_url` en el descriptor (hoy manda `null`). Mismo patrón que
 * agent-colors.js: si el kernel llega a mandar `avatar_url`, GANA; si no, se
 * resuelve por id desde este mapa. Las imágenes viven en /public/avatars/<id>.jpg
 * (retrato ~3:4, «foto extendida» de la ficha del agente).
 *
 * Es dato de presentación, no de negocio: el front no decide quién existe ni
 * qué puede hacer (eso sigue en el descriptor / R-PT-02); solo le pone cara a un
 * id que el kernel ya reconoce. Cuando el kernel emita `avatar_url`, este mapa
 * queda inerte sin tocar código.
 */

export const AGENT_PHOTOS = {
  anne:    '/avatars/anne.jpg',
  julia:   '/avatars/julia.jpg',
  jorge:   '/avatars/jorge.jpg',
  melissa: '/avatars/melissa.jpg',
  erin:    '/avatars/erin.jpg',
  jimmy:   '/avatars/jimmy.jpg',
  cassie:  '/avatars/cassie.jpg',
  seo:     '/avatars/seo.jpg',
  max:     '/avatars/max.jpg',
  linda:   '/avatars/linda.jpg',
  nancy:   '/avatars/nancy.jpg',
  nick:    '/avatars/nick.jpg',
  grace:   '/avatars/grace.jpg',
  jack:    '/avatars/jack.jpg',
  werner:  '/avatars/werner.jpg',
  vint:    '/avatars/vint.jpg',
  linus:   '/avatars/linus.jpg',
  amy:     '/avatars/amy.jpg',
  satya:   '/avatars/satya.jpg',
}

// Foto a usar para un agente. Prioridad: `avatar_url` del descriptor (si el
// kernel lo emite) -> mapa del front por id -> null (AgentAvatar cae a iniciales).
export function avatarUrlOf(agent) {
  if (!agent) return null
  if (agent.avatar_url) return agent.avatar_url
  return (agent.id && AGENT_PHOTOS[agent.id]) || null
}
